import type { TenantConfig } from '@/types/TenantConfig'

export const hofmyrtlebeach: TenantConfig = {
  logo: 'assets/hofmyrtlebeach/static/logo.png',
  themeOptions: {
    dialog: {
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBackground: '#000000',
    },
  },
  teaserImageSize: {
    height: 208,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/hofmyrtlebeach/static/completed-desktop.jpeg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;1,400;1,600&family=Oswald:wght@400;700&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        fixedFees: 'Convenience Fee',
      },
    },
  },
}
